import { BottomPanelTabs, RightPanelTabs } from '../locations-skeleton.component';

// Type

export interface LocationsSkeletonState {
  containerDimensionsInitialized: boolean,
  resizing: boolean, // true for the duration of bottom/right panel 'resizing' event

  // right panel
  rightPanelActive: boolean,
  selectedRightPanelTab: RightPanelTabs,
  unsavedChangesInRightPanelTab: boolean, // if there are unsaved changes, this needs to be true
  rightPanelRelativeWidth: number,

  // bottom panel
  bottomPanelActive: boolean,
  selectedBottomPanelTab: BottomPanelTabs,
  unsavedChangesInBottomPanelTab: boolean, // if there are unsaved changes, this needs to be true
  bottomPanelRelativeHeight: number,
}

// Initial State

export const initialState: LocationsSkeletonState = {
  containerDimensionsInitialized: false,
  resizing: false,

  rightPanelActive: false,
  selectedRightPanelTab: RightPanelTabs.MAP,
  unsavedChangesInRightPanelTab: false,
  rightPanelRelativeWidth: 0,

  bottomPanelActive: false,
  selectedBottomPanelTab: BottomPanelTabs.CC_RESULTS,
  unsavedChangesInBottomPanelTab: false,
  bottomPanelRelativeHeight: 0,
};
